const module = { name: 'movie/layouts/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_pageDetails } from 'require-core';

const { pageDetails } = Fandango_pageDetails;


const { loadReviews } = readPageContext(pageDetails)


import { default as backgroundBlur } from 'swug-fdRequire-call:movie/shared/desktop/backgroundBlur';



import { default as mopReviews } from 'swug-fdRequire-call:movie/shared/desktop/mopReviews';



import { default as movieStateUI } from 'swug-fdRequire-call:movie/shared/desktop/movieStateUI';



import { default as rottenTomatoes } from 'swug-fdRequire-call:movie/shared/desktop/rottenTomatoes';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';

function readPageContext(pageDetails) {
    return {
        loadReviews: pageDetails && pageDetails.loadReviews
    };
}
function run() {
    checkDependencies(module.name, debugLog);
    if (loadReviews) {
        mopReviews.init();
    }
    movieStateUI.run();
    backgroundBlur.init();
    rottenTomatoes.init();
    hearts.init();
}
run();
export default module.exports;